const homeFR = {
  home_nav_about: 'À Propos',
  home_nav_companies: 'Nos Entreprises',
  home_nav_services: 'Services',
  home_nav_investment: 'Investissement',
  home_nav_contact: 'Contact',
  home_nav_getStarted: 'Commencer',

  home_hero_badge: "Société Holding Leader du Développement Africain",
  home_hero_title: "Connecter l'Avenir de l'Afrique\naux Opportunités Mondiales",
  home_hero_subtitle: "Partenariats stratégiques • Facilitation des investissements • Développement durable en Afrique",
  home_hero_cta1: 'Explorer Nos Entreprises',
  home_hero_cta2: 'Voir les Projets',

  home_about_tag: 'Qui Nous Sommes',
  home_about_title: "Au Cœur de l'Écosystème Décisionnel de l'Afrique",
  home_about_desc: "Grâce à notre vaste réseau de dirigeants gouvernementaux, de partenaires institutionnels et d'investisseurs mondiaux, nous aidons à concrétiser des projets transformationnels à travers le continent. GDSATLAS sert de pont vital entre les projets visionnaires et les ressources et partenariats nécessaires pour les réaliser.",
  home_about_quote: "Notre mission est de faciliter les partenariats stratégiques, de mobiliser des investissements internationaux et de réaliser des projets de développement durable en Afrique grâce à nos filiales spécialisées.",
  home_about_badge: '50+',
  home_about_badge_sub: 'Partenaires',

  home_exp_tag: 'Notre Expertise',
  home_exp_title: 'Solutions Complètes pour le Développement Africain',
  home_exp_subtitle: 'Nous nous spécialisons dans la mise en relation des entreprises avec des opportunités dans de multiples secteurs',
  home_exp_c1_title: 'Facilitation de Projets',
  home_exp_c1_desc: "Connecter les entreprises aux dirigeants africains, décideurs et investisseurs pour concrétiser des projets transformateurs sur tout le continent. Nous naviguons dans des environnements réglementaires complexes et construisons les ponts nécessaires au succès.",
  home_exp_c1_t1: 'Liaison Gouvernementale',
  home_exp_c1_t2: 'Structuration de Deals',
  home_exp_c1_t3: 'Navigation Réglementaire',
  home_exp_c2_title: 'Conseil & Consulting',
  home_exp_c2_l1: 'Partenariats Public-Privé (PPP)',
  home_exp_c2_l2: 'Modèles Build-Operate-Transfer (BOT)',
  home_exp_c2_l3: "Stratégies d'entrée sur le marché",
  home_exp_c2_l4: "Structuration d'investissements",
  home_exp_c2_t1: 'PPP',
  home_exp_c2_t2: 'BOT',
  home_exp_c2_t3: 'Stratégie',
  home_exp_c3_title: "Solutions d'Investissement",
  home_exp_c3_desc: "Sécuriser le financement et les partenariats grâce à notre réseau international d'investisseurs, offrant un accès au capital pour des projets transformateurs en Afrique. Nous associons les bons investisseurs aux bonnes opportunités.",
  home_exp_c3_t1: 'Mobilisation de Capitaux',
  home_exp_c3_t2: "Mise en Relation d'Investisseurs",
  home_exp_c3_t3: 'Évaluation des Risques',
  home_exp_c4_title: 'Expertise Sectorielle',
  home_exp_c4_l1: 'Pétrole et Gaz',
  home_exp_c4_l2: 'Développement des Infrastructures',
  home_exp_c4_l3: 'Énergie & Mines',
  home_exp_c4_l4: 'Agriculture & Logistique',
  home_exp_c4_t1: 'Pétrole & Gaz',
  home_exp_c4_t2: 'Mines',
  home_exp_c4_t3: 'Infrastructure',

  home_part_tag: 'Capacités de Partenariat',
  home_part_title: 'Conçu pour des Partenariats Commerciaux Stratégiques',
  home_part_subtitle: "GDSATLAS réunit les réseaux, l'expertise et la capacité opérationnelle pour faire des partenariats à fort impact une réalité en Afrique",
  home_part_f1_tag: 'Alliances Stratégiques',
  home_part_f1_title: 'Partenariats Gouvernementaux & Institutionnels',
  home_part_f1_desc: "Relations directes avec des chefs d'État, ministres et institutions en Afrique de l'Ouest, permettant des approbations accélérées et un accès privilégié aux opportunités stratégiques.",
  home_part_f2_tag: 'Rayonnement Mondial',
  home_part_f2_title: "Réseau International d'Investisseurs",
  home_part_f2_desc: "Accès à un réseau sélectionné d'investisseurs mondiaux activement à la recherche d'opportunités de croissance en Afrique.",
  home_part_f3_tag: 'Infrastructure',
  home_part_f3_title: 'Exécution de Projets à Grande Échelle',
  home_part_f4_tag: 'Énergie',
  home_part_f4_title: 'Projets Énergétiques Durables',
  home_part_f5_tag: 'Agriculture',
  home_part_f5_title: "Agribusiness & Sécurité Alimentaire",
  home_part_s1_value: '15+',
  home_part_s1_label: 'Partenaires Gouvernementaux',
  home_part_s1_sub: "En Afrique de l'Ouest",
  home_part_s2_value: '30+',
  home_part_s2_label: 'Investisseurs Internationaux',
  home_part_s2_sub: 'Actifs dans notre réseau',
  home_part_s3_value: '$2B+',
  home_part_s3_label: 'Projets Facilités',
  home_part_s3_sub: 'En valeur totale',
  home_part_s4_value: '8+',
  home_part_s4_label: 'Pays Africains',
  home_part_s4_sub: 'Opérations actives',

  home_sub_tag: 'Nos Entreprises',
  home_sub_title: 'Trois Filiales Spécialisées',
  home_sub_subtitle: "Entièrement détenues par GDSATLAS, nos entreprises excellent dans les secteurs minier, logistique et halieutique",
  home_compass_title: 'Compass Resources',
  home_compass_desc: "Société minière avant-gardiste dédiée à l'exploration et à l'exploitation durable des riches ressources minérales de la Mauritanie, notamment l'or, l'uranium, le cuivre, le quartz et le sable noir.",
  home_compass_stat1: '1 352 km²',
  home_compass_stat1_label: 'Surface Totale de Licences',
  home_compass_stat2: '5+',
  home_compass_stat2_label: 'Ressources Minérales',
  home_compass_cta: 'Explorer les Opérations Minières',
  home_mauritrans_title: 'Mauritrans Shipping',
  home_mauritrans_desc: "Société complète de logistique et de transport maritime offrant des services de bout en bout, d'affrètement, de dédouanement et de solutions de chaîne d'approvisionnement à travers l'Afrique et à l'international.",
  home_mauritrans_stat1: '500+',
  home_mauritrans_stat1_label: 'Expéditions Annuelles',
  home_mauritrans_stat2: '9',
  home_mauritrans_stat2_label: 'Catégories de Services',
  home_mauritrans_cta: 'Explorer les Services Logistiques',
  home_transfish_title: 'Trans-Fish',
  home_transfish_desc: "Entreprise dynamique opérant dans le secteur halieutique, tirant parti des riches eaux côtières atlantiques de la Mauritanie pour offrir des opérations de pêche durables, de transformation des produits de la mer et des solutions d'exportation vers les marchés internationaux.",
  home_transfish_stat1: 'Atlantique',
  home_transfish_stat1_label: 'Opérations Côtières',
  home_transfish_stat2: 'Export',
  home_transfish_stat2_label: 'Marchés Internationaux',
  home_transfish_cta: 'Visiter le Site Trans-Fish',

  home_inv_title: "Prêt à Investir\nen Afrique ?",
  home_inv_desc: "GDSATLAS accueille des partenariats dans les secteurs de l'Infrastructure, de l'Énergie,\ndes Mines, de l'Agriculture et du Développement Industriel.",
  home_inv_cta1: "Explorer les Opportunités",
  home_inv_cta2: 'Planifier une Consultation',

  home_why_tag: 'Pourquoi Nous Choisir',
  home_why_title: "Votre Porte d'Entrée vers le Succès en Afrique",
  home_why_subtitle: "Exploiter une expertise approfondie et de vastes réseaux pour obtenir des résultats exceptionnels",
  home_why_01_title: 'Solides Relations Gouvernementales',
  home_why_01_desc: "Accès direct aux décideurs africains et dirigeants gouvernementaux dans plusieurs pays",
  home_why_02_title: "Réseau Mondial d'Investisseurs",
  home_why_02_desc: "Connexions étendues avec des investisseurs internationaux cherchant des opportunités africaines",
  home_why_03_title: 'Expertise PPP & BOT',
  home_why_03_desc: "Connaissance spécialisée dans la structuration de Partenariats Public-Privé et de projets Build-Operate-Transfer",
  home_why_04_title: 'Logistique Intégrée',
  home_why_04_desc: "Capacités complètes d'expédition et de logistique garantissant une exécution de projet fluide",
  home_why_05_title: 'Intelligence du Marché Africain',
  home_why_05_desc: "Compréhension approfondie des marchés locaux, des réglementations et des environnements commerciaux",
  home_why_06_title: 'Bilan Prouvé',
  home_why_06_desc: "A facilité avec succès de nombreux projets transformationnels à travers le continent",

  home_contact_tag: 'Nous Contacter',
  home_contact_title: "Construisons Ensemble l'Avenir de l'Afrique",
  home_contact_subtitle: 'Contactez GDSATLAS pour discuter de votre projet ou de vos opportunités d\'investissement',
  home_contact_addr_label: 'Adresse',
  home_contact_phone_label: 'Téléphone',
  home_contact_email_label: 'Email',
  home_contact_web_label: 'Site Web',
  home_contact_subs_title: 'Nos Filiales',
  home_contact_compass: 'Compass Resources - Opérations Minières',
  home_contact_mauritrans: 'Mauritrans Shipping - Services Logistiques',
  home_contact_transfish: 'Trans-Fish - Pêche & Export de Produits de la Mer',
  home_form_title: 'Envoyez-nous un message',
  home_form_name: 'Nom',
  home_form_name_ph: 'Votre nom',
  home_form_email: 'Email',
  home_form_email_ph: 'votre@email.com',
  home_form_message: 'Message',
  home_form_message_ph: "Parlez-nous de votre projet ou de votre demande",
  home_form_submit: 'Envoyer le Message',

  home_footer_tagline: "Connecter l'Afrique aux Opportunités Mondiales",
  home_footer_subscribe: 'Restez Informé',
  home_footer_subscribe_ph: 'Votre email',
  home_footer_subscribe_btn: "S'abonner",
  home_footer_companies: 'Nos Entreprises',
  home_footer_services: 'Services',
  home_footer_svc1: 'Facilitation de Projets',
  home_footer_svc2: 'Conseil & Consulting',
  home_footer_svc3: "Solutions d'Investissement",
  home_footer_svc4: 'Expertise Sectorielle',
  home_footer_contact: 'Contact',
  home_footer_copyright: '© 2025 GDSATLAS Holding. Tous droits réservés.',
};

export default homeFR;
